import React, { useContext } from "react";
import { FarmerContext } from "./FarmerContext";
import { Link } from "react-router-dom";
import Pagination from "../../Pagination";
import "./farmerBanks.css"
import { Spinner } from "react-bootstrap";
export default function FarmerBanks() {

  const {
    data,
    formik,
    setRelToDel,
    availableBanks, // Default to an empty array
    newBanksData,
    currentPage,
    postsPerPage,
    paginate,
    farmerBanks,
  } = useContext(FarmerContext);

  const shouldPaginate = farmerBanks.length > 4;
  const displayedBanks= shouldPaginate ? newBanksData : farmerBanks;

  // Safeguard to avoid errors when availableBanks is not yet available
  const farmerBanksName = availableBanks ? availableBanks.map((bank) => bank.name) : [];

  const handleDeleteClick = (bankname) => {
    formik.setFieldValue("name", bankname);
    setRelToDel(true);
    };

  return (
    <div className="max-w-full min-w-fit mb-10">
      <div>
      <Link to="/FarmerDash/communicate/bankowners">Communicate</Link>
      </div>
      <p className="font-bold">BANKS</p>
      <div>
        {displayedBanks.length > 0 ?
        <div className="bank-grid  mt-6">
          {displayedBanks.map((bank) => (
            <div key={bank.id} className="bank-card ">
              <form onSubmit={formik.handleSubmit} className=" flex flex-initial ml-0">
               <button className=" bg-red-500  rounded-lg flex flex-initial ml-0" type="submit" onClick={()=>handleDeleteClick(bank.name)}>
                DELETE
               </button>
              </form>
              <div className="bank-container ">
                <img src={bank.image_url} alt={bank.name} className="bank-image"                 
                />
                <div className="data-overlay">
                  <p className="text-white italic ">{bank.name}</p>
                  <p className="text-white italic ">{bank.email}</p>
                  <h4 className="text-white italic ">{bank.hq_location}</h4>
                  <p className="text-white italic ">{bank.paybill}</p>
                </div>
                 {/* <button className="edit-button bg-red-500" onClick={() =>handleDeleteClick(bank.name) }>EDIT</button> */}
               
              </div>
            </div>
          ))}
        </div>
        : <p>Sorry, there are no banks </p>}   
        </div> 
      {shouldPaginate ? (
        <Pagination
          postsPerPage={postsPerPage}
          totalPosts={farmerBanks.length}
          currentPage={currentPage}
          paginate={paginate}
        />
      ) : null}
      {availableBanks.length > 0 ? (
        <form onSubmit={formik.handleSubmit}>
          <label htmlFor="name">Select Bank to add</label>
          <select
            onChange={formik.handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            value={formik.values.name}
            name="name"
            id="name"
          >
            <option>Select a bank</option>
            {farmerBanksName.map((bank, index) => (
              <option value={bank} key={index}>
                {bank}
              </option>
            ))}
          </select>
          <button
            type="submit"
            className="bg-blue-500 rounded-lg text-white disabled:opacity-50"
            disabled={formik.isSubmitting || !formik.isValid}
          >
            Send request
          </button>
        </form>
      ) : null}
    </div>
  );
}




